/*
//Compair and Pair Scroll Button
(() => {
    // const scrollAmount = 200;

    function updateComparePairButtonVisibility(container, btnGroup, btnLeft, btnRight) {

        const isScrollable = container.scrollWidth > container.clientWidth;

        if(!isScrollable){
            btnGroup.style.display = "none";
            return
        } else {
            btnGroup.style.display = "flex";
        }

        const currentScroll = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;

        btnLeft.style.opacity = currentScroll > 5 ? '1' : '0.5';
        btnLeft.style.pointerEvents = currentScroll > 5 ? 'auto' : 'none';

        btnRight.style.opacity = currentScroll < maxScroll - 5 ? '1' : '0.5';
        btnRight.style.pointerEvents = currentScroll < maxScroll - 5 ? 'auto' : 'none';
    }

    function comparePairButtons(root = document){
        const container = root.querySelector('.compare-pair_table-wrap');
        const btnGroup = root.querySelector('.compare-pair_button-group');
        const btnLeft = root.getElementById('compare-pair_scroll-left');
        const btnRight = root.getElementById('compare-pair_scroll-right');

        if(!container || !btnGroup || !btnLeft || !btnRight) return;

        // to get "td" width
        const getScrollStep = () => {
            const firstCell = container.querySelector('td');
            return firstCell ? firstCell.offsetWidth : 200;
        };

        btnLeft.replaceWith(btnLeft.cloneNode(true));
        btnRight.replaceWith(btnRight.cloneNode(true));

        const newBtnLeft = root.getElementById('compare-pair_scroll-left');
        const newBtnRight = root.getElementById('compare-pair_scroll-right');

        newBtnLeft.addEventListener('click', () => {
            const currentScroll = container.scrollLeft;
            const step = getScrollStep();
            const isMobile = window.innerWidth <= 676;
            
            if (isMobile && currentScroll < 100) {
                container.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                container.scrollBy({ left: -step, behavior: 'smooth' });
            }
        });

        newBtnRight.addEventListener('click', () => {
            const currentScroll = container.scrollLeft;
            const step = getScrollStep();
            const isMobile = window.innerWidth <= 676;

            if (isMobile && currentScroll < 5) {
                container.scrollTo({ left: 90, behavior: 'smooth' });
            } else {
                container.scrollBy({ left: step, behavior: 'smooth' });
            }
        });

        container.addEventListener('scroll', () => {
            updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight)
        });

        window.addEventListener('resize', () => {
            updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight)
        });

        updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight);
    }

    document.addEventListener("DOMContentLoaded", () => {
        comparePairButtons(document);
    });

    document.addEventListener("shopify:section:load", (e) => {
        comparePairButtons(e.target);
    });

    document.addEventListener("shopify:section:select", (e) => {
        comparePairButtons(e.target);
    });

    document.addEventListener("shopify:section:reorder", () => {
        comparePairButtons(document);
    });
})();

*/

// Good To Know Expand Button
document.addEventListener("DOMContentLoaded", function () {
  let tabTrigger = '.tab-expend-btn'
  
  let tabClasses = {
    hide: 'hide',
    open: 'tab-is-open',
    autoHeight: 'tab--auto-height'
  }

  document.querySelectorAll(tabTrigger).forEach(function (btn){
    btn.addEventListener('click',function(evt){
      
      let el = evt.currentTarget
      let isOpen = el.classList.contains(tabClasses.open)
      let moduleId = el.getAttribute('aria-controls')
      let container = document.getElementById(moduleId)

      let fullHeight = container.scrollHeight + 'px';
    
      if (!moduleId) {
        moduleId = el.dataset.controls
      }
    
      if (!moduleId) {
        return
      }

      if (isOpen) {
        el.classList.remove(tabClasses.open),
        container.classList.remove(tabClasses.open),
        container.style.height = '650px',
        btn.style.setProperty('--before-content', '"View More"');

        setTimeout(() => {
          const offset = 70;
          const elementPosition = btn.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - window.innerHeight + btn.offsetHeight + offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 10);

      } else {
        el.classList.add(tabClasses.open),
        container.classList.add(tabClasses.open),
        container.style.height = fullHeight,
        btn.style.setProperty('--before-content', '"View Less"');
      }
      
    });
  });


  const openButtons = document.querySelectorAll('.js-drawer-open');
  const closeButtons = document.querySelectorAll('.js-drawer-close');

  openButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-target');
      const targetDrawer = document.getElementById(targetId);

      if (targetDrawer) {
        targetDrawer.classList.add('active');
        document.body.classList.add('drawer-open');
      }
    });
  });

  const closeAll = () => {
    document.querySelectorAll('.pdp_des_drawer.active').forEach(drawer => {
      drawer.classList.remove('active');
    });
    // overlay.classList.remove('is-visible');
    document.body.classList.remove('drawer-open');
  };

  closeButtons.forEach(btn => {
    btn.addEventListener('click', closeAll);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });


  // New: mobile drag to close function
  let touchStartY = 0;
  let isReadyToClose = false;

  document.querySelectorAll('.pdp_des_drawer').forEach(drawer => {
    const wrapper = drawer.querySelector('.des_drawer_wrapper');
    if (!wrapper) return;

    // 1. when touching screen
    wrapper.addEventListener('touchstart', (e) => {
      if (window.innerWidth >= 768) return; // Only Mobile

      // only active "ready to close" function when close to top
      if (wrapper.scrollTop <= 50) {
        touchStartY = e.touches[0].pageY;
        touchStartScrollTop = wrapper.scrollTop; // recording currently is 0px or 15px
        isReadyToClose = true;
      } else {
        isReadyToClose = false;
      }
    }, { passive: true });

    // 2. when releasing touch
    wrapper.addEventListener('touchend', (e) => {
      if (!isReadyToClose) return;

      // in touchend event, must use changedTouches to get the last position of finger
      const touchEndY = e.changedTouches[0].pageY;
      // const deltaY = touchEndY - touchStartY;  //count the total sliding distance
      const deltaY = (touchEndY - touchStartY) - touchStartScrollTop;

      // if scroll down more than 150px, active close function after releasing touch
      if (deltaY > 150) { 
        closeAll();
      }

      // reset variable not matter actived function or not
      isReadyToClose = false;
    });
  });

});

/*
(() => {
  const initScrollSection = () => {
    const sectionId = 'ys-bought-together-section';
    const root = document.getElementById(sectionId);

    if (!root) return;

    const container = root.querySelector('.ys-bought-together-scrollable');
    const btnGroup = root.querySelector('.ys-product-list_button-group');
    
    const btnLeft = root.querySelector('#ys-scroll-left');
    const btnRight = root.querySelector('#ys-scroll-right');

    if (!container || !btnLeft || !btnRight) return;

    // 用于老版本 Safari 的定时器变量
    let scrollTimeout = null;

    const updateButtons = () => {
        const currentScroll = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;
        
        const isScrollable = container.scrollWidth > container.clientWidth + 5;

        if (!isScrollable) {
            if (btnGroup) btnGroup.style.display = "none";
            return;
        }
        if (btnGroup) btnGroup.style.display = "flex";

        btnLeft.style.opacity = currentScroll > 5 ? '1' : '0.3';
        btnLeft.style.pointerEvents = currentScroll > 5 ? 'auto' : 'none';

        btnRight.style.opacity = currentScroll < maxScroll - 5 ? '1' : '0.3';
        btnRight.style.pointerEvents = currentScroll < maxScroll - 5 ? 'auto' : 'none';
    };

    // 【新增】核心精准算法：获取所有子元素相对于滚动容器的绝对精确坐标（带浮点数）
    const getSnapPositions = () => {
        const items = container.querySelectorAll('.ys-related-product-item');
        const containerRect = container.getBoundingClientRect();
        return Array.from(items).map(item => {
            return item.getBoundingClientRect().left - containerRect.left + container.scrollLeft;
        });
    };

    // 【新增】核心兼容函数：平滑滚动并完美兼容 Safari 的 Scroll Snap 冲突
    const smoothScrollTo = (targetLeft) => {
        // 1. 临时关闭 Scroll Snap，防止 Safari 的内核与 JS 动画“打架”
        container.style.scrollSnapType = 'none';
        
        // 2. 触发精准滚动
        container.scrollTo({ left: targetLeft, behavior: 'smooth' });

        // 3. 滚动结束后恢复 Scroll Snap 机制
        const handleScrollEnd = () => {
            container.style.scrollSnapType = ''; // 恢复 CSS 中的默认设置
            container.removeEventListener('scrollend', handleScrollEnd);
        };

        // 优先使用现代浏览器原生支持的 scrollend 事件
        if ('onscrollend' in window) {
            container.addEventListener('scrollend', handleScrollEnd);
        } else {
            // 针对不支持 scrollend 的老旧 Safari 版本使用 setTimeout 兜底
            if (scrollTimeout) clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(handleScrollEnd, 400); // 400ms 刚好是平滑滚动的标准时间
        }
    };

    // 左翻页按钮逻辑
    btnLeft.onclick = () => {
        const snapPositions = getSnapPositions();
        if (snapPositions.length === 0) return;

        const currentScroll = container.scrollLeft;
        const idealTarget = currentScroll - container.clientWidth;

        // 寻找最接近理想翻页位置的吸附点
        let targetScroll = snapPositions.slice().reverse().find(pos => pos <= idealTarget + 10);
        if (targetScroll === undefined) targetScroll = snapPositions[0];

        // 安全兜底：如果算出的目标没发生位移，强制往前推一个元素，防止“卡死”
        if (targetScroll >= currentScroll - 5 && snapPositions.length > 1) {
            const currentIndex = snapPositions.findIndex(pos => pos >= currentScroll - 5);
            if (currentIndex > 0) targetScroll = snapPositions[currentIndex - 1];
        }

        smoothScrollTo(targetScroll);
    };

    // 右翻页按钮逻辑
    btnRight.onclick = () => {
        const snapPositions = getSnapPositions();
        if (snapPositions.length === 0) return;

        const currentScroll = container.scrollLeft;
        const idealTarget = currentScroll + container.clientWidth;

        // 寻找最接近理想翻页位置的吸附点
        let targetScroll = snapPositions.find(pos => pos >= idealTarget - 10);
        if (targetScroll === undefined) targetScroll = snapPositions[snapPositions.length - 1];

        // 安全兜底：如果算出的目标没发生位移，强制往后推一个元素，防止“卡死”
        if (targetScroll <= currentScroll + 5 && snapPositions.length > 1) {
            const currentIndex = snapPositions.findIndex(pos => pos >= currentScroll - 5);
            if (currentIndex !== -1 && currentIndex < snapPositions.length - 1) {
                targetScroll = snapPositions[currentIndex + 1];
            }
        }

        smoothScrollTo(targetScroll);
    };

    container.removeEventListener('scroll', updateButtons);
    window.removeEventListener('resize', updateButtons);

    container.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    setTimeout(updateButtons, 100);
  };

  if (document.readyState === 'complete') {
    initScrollSection();
  } else {
    window.addEventListener('load', initScrollSection);
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sectionTarget = document.getElementById('ys-bought-together-section');
    if (sectionTarget && sectionTarget.closest(`#shopify-section-${e.detail.sectionId}`)) {
        initScrollSection();
    }
  });

})();
*/

(() => {
  const sourceContainer = document.querySelector('.ys-block-list');
  const targetContainer = document.querySelector('.ys-block-list--mobile');

  if (!sourceContainer || !targetContainer) return;

  let htmlContent = sourceContainer.innerHTML;

  function moveHeader() {

      if (window.innerWidth < 769) {
          if (targetContainer.children.length === 0) {
              while (sourceContainer.firstChild) {
                  targetContainer.appendChild(sourceContainer.firstChild);
              }
          }
      } else {
          if (sourceContainer.children.length === 0) {
              while (targetContainer.firstChild) {
                  sourceContainer.appendChild(targetContainer.firstChild);
              }
          }
      }
  }

  moveHeader();

  window.addEventListener('resize', moveHeader);
})();

(() => {
  const ctn2 = document.querySelector('.ys-product-details-main-ctn-2');
  const targetElement = document.querySelector('.ys-product-details-main-ctn-1 .tab-expendable');

  if (ctn2 && targetElement) {
      const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
              const ctn2Height = entry.target.offsetHeight; 
              
              targetElement.style.height = `${ctn2Height - 85 }px`;
          }
      });

      resizeObserver.observe(ctn2);
  }
})();

(() => {
  document.addEventListener('DOMContentLoaded', function() {
    
    const sizeRow = document.getElementById('shopify-compare-pair-size-row');
      
    if (sizeRow) {
      sizeRow.addEventListener('click', function(e) {
        const isToggleBtn = e.target.classList.contains('compare-pair-size-toggle-btn');
        const isMoreDots = e.target.classList.contains('compare-pair-size-more-dots');

        if (isToggleBtn || isMoreDots) {
          sizeRow.classList.toggle('expanded');
          
          const toggleBtn = sizeRow.querySelector('.compare-pair-size-toggle-btn');
          if (toggleBtn) {
            toggleBtn.textContent = sizeRow.classList.contains('expanded') ? '[-]' : '[+]';
          }
        }
      });
    }
  });
})();


/* ====================================================================================================================================
 -------------------------- Change Delivery Package Info (Dimension & Weight) when select Product Variant --------------------------
==================================================================================================================================== */


(function () {

  function formatNumber(value) {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const number = Number(value);

    if (Number.isNaN(number)) {
      return String(value);
    }

    return Number.isInteger(number)
      ? String(number)
      : String(parseFloat(number.toFixed(2)));
  }


  function formatDimensionUnit(unit) {
    const units = {
      MILLIMETERS: 'mm',
      CENTIMETERS: 'cm',
      METERS: 'm',
      INCHES: 'in',
      FEET: 'ft',
      mm: 'mm',
      cm: 'cm',
      m: 'm',
      in: 'in',
      ft: 'ft'
    };

    return units[unit] || unit || '';
  }


  function formatWeightUnit(unit) {
    const units = {
      KILOGRAMS: 'kg',
      GRAMS: 'g',
      POUNDS: 'lb',
      OUNCES: 'oz',
      kg: 'kg',
      g: 'g',
      lb: 'lb',
      oz: 'oz'
    };

    return units[unit] || unit || '';
  }


  function formatWeight(weight) {
    if (
      !weight ||
      weight.value === null ||
      weight.value === undefined ||
      weight.value === ''
    ) {
      return '';
    }

    return (
      formatNumber(weight.value) +
      formatWeightUnit(weight.unit)
    );
  }


  function formatDimensions(dimensions) {
    if (
      !Array.isArray(dimensions) ||
      dimensions.length === 0
    ) {
      return '';
    }

    const labels = ['L', 'W', 'H'];

    const validDimensions = dimensions.filter(function (dimension) {
      return (
        dimension &&
        dimension.value !== null &&
        dimension.value !== undefined &&
        dimension.value !== ''
      );
    });

    if (!validDimensions.length) {
      return '';
    }

    const isInches = validDimensions.every(function (dimension) {
      return (
        dimension.unit === 'INCHES' ||
        dimension.unit === 'in'
      );
    });

    const parts = validDimensions.map(function (dimension, index) {
      const value =
        labels[index] +
        formatNumber(dimension.value);

      // Inch symbol goes after every dimension
      return isInches
        ? value + '”'
        : value;
    });

    if (isInches) {
      return parts.join(' x ');
    }

    const unit = formatDimensionUnit(
      validDimensions[0].unit
    );

    return parts.join(' x ') + unit;
  }

  function calculateVolume(dimensions) {

    if (
      !Array.isArray(dimensions) ||
      dimensions.length < 3
    ) {
      return null;
    }

    const validDimensions = dimensions.filter(function (dimension) {
      return (
        dimension &&
        dimension.value !== null &&
        dimension.value !== undefined &&
        dimension.value !== '' &&
        !Number.isNaN(Number(dimension.value))
      );
    });

    // Volume requires L × W × H
    if (validDimensions.length < 3) {
      return null;
    }

    const length = Number(validDimensions[0].value);
    const width = Number(validDimensions[1].value);
    const height = Number(validDimensions[2].value);

    const units = validDimensions.map(function (dimension) {
      return dimension.unit;
    });

    const isMillimeters = units.every(function (unit) {
      return (
        unit === 'MILLIMETERS' ||
        unit === 'mm'
      );
    });

    const isInches = units.every(function (unit) {
      return (
        unit === 'INCHES' ||
        unit === 'in'
      );
    });


    // mm³ → m³
    if (isMillimeters) {

      return {
        value:
          (length * width * height) /
          1000000000,

        unit: 'cbm'
      };

    }


    // in³ → ft³
    if (isInches) {

      return {
        value:
          (length * width * height) /
          1728,

        unit: 'cuft'
      };

    }


    return null;
  }

  function formatVolume(volume) {

    if (
      !volume ||
      volume.value === null ||
      volume.value === undefined ||
      Number.isNaN(Number(volume.value))
    ) {
      return '';
    }

    const value = Number(volume.value);

    return (
      value.toFixed(2) +
      volume.unit
    );
  }


  function updatePackageInfo(container, variantId) {

    if (!container || !variantId) {
      return;
    }

    const productId = container.dataset.productId;

    const jsonElement = document.querySelector(
      '[data-variant-package-json="' + productId + '"]'
    );

    if (!jsonElement) {
      return;
    }

    let allVariantData;

    try {
      allVariantData = JSON.parse(
        jsonElement.textContent
      );
    } catch (error) {
      console.error(
        'Unable to parse variant package data:',
        error
      );
      return;
    }

    const variantData =
      allVariantData[String(variantId)];

    if (!variantData) {
      container.hidden = true;
      return;
    }


    /* =========================
       BOXES
    ========================= */

    const boxesContainer =
      container.querySelector('[data-package-boxes]');

    boxesContainer.innerHTML = '';

    let visibleBoxCount = 0;

    let totalCbm = 0;
    let totalCuft = 0;

    variantData.boxes.forEach(function (box) {

      const dimensions =
        formatDimensions(box.dimensions);

      const weight =
        formatWeight(box.weight);

      const volumeData =
        calculateVolume(box.dimensions);

      const volume =
        formatVolume(volumeData);


      if (volumeData) {

        if (volumeData.unit === 'cbm') {

          totalCbm +=
            Number(volumeData.value);

        }

        if (volumeData.unit === 'cuft') {

          totalCuft +=
            Number(volumeData.value);

        }

      }

      // Check whether this box really has dimension data
      const hasDimensions =
        Array.isArray(box.dimensions) &&
        box.dimensions.some(function (dimension) {
          return (
            dimension &&
            dimension.value !== null &&
            dimension.value !== undefined &&
            dimension.value !== ''
          );
        });

      // Check whether this box really has weight data
      const hasWeight =
        box.weight &&
        box.weight.value !== null &&
        box.weight.value !== undefined &&
        box.weight.value !== '';


      // Ignore completely empty boxes
      if (!hasDimensions && !hasWeight) {
        return;
      }

      visibleBoxCount++;

      const row =
        document.createElement('div');

      row.className =
        'variant-package-info__box';

      const boxDetails = [];

      if (weight) {
        boxDetails.push(weight);
      }

      if (volume) {
        boxDetails.push(volume);
      }

      row.innerHTML =
        '<strong class="variant-package-info__box-label">' +
          'Box ' + box.number + ':' +
        '</strong>' +

        (dimensions
          ? ' <span class="variant-package-info__box-dimensions">' +
              dimensions +
            '</span>'
          : '') +

        (boxDetails.length
          ? ' <span class="variant-package-info__box-weight">(' +
              boxDetails.join('/') +
            ')</span>'
          : '');

      boxesContainer.appendChild(row);
    });


    /* =========================
       TOTAL ACTUAL WEIGHT
    ========================= */

    const actualWeightRow =
      container.querySelector(
        '[data-actual-weight-row]'
      );

    const actualWeightElement =
      container.querySelector(
        '[data-actual-weight]'
      );

    const actualWeight =
      formatWeight(
        variantData.total_actual_weight
      );

    if (actualWeight) {

      actualWeightElement.textContent =
        actualWeight;

      actualWeightRow.hidden = false;

    } else {

      actualWeightRow.hidden = true;

    }


    /* =========================
      TOTAL VOLUME
    ========================= */

    const totalVolumeRow =
      container.querySelector(
        '[data-total-volume-row]'
      );

    const totalVolumeElement =
      container.querySelector(
        '[data-total-volume]'
      );


    let totalVolumeText = '';


    if (totalCbm > 0 && totalCuft > 0) {

      totalVolumeText =
        totalCbm.toFixed(2) +
        'cbm / ' +
        totalCuft.toFixed(2) +
        'cuft';

    } else if (totalCbm > 0) {

      totalVolumeText =
        totalCbm.toFixed(2) +
        'cbm';

    } else if (totalCuft > 0) {

      totalVolumeText =
        totalCuft.toFixed(2) +
        'cuft';

    }


    if (totalVolumeText) {

      totalVolumeElement.textContent =
        totalVolumeText;

      totalVolumeRow.hidden = false;

    } else {

      totalVolumeRow.hidden = true;

    }


    /* =========================
       BOX TOTAL COUNT
    ========================= */

    const packageTotalRow =
      container.querySelector(
        '[data-package-total-row]'
      );

    const packageTotalElement =
      container.querySelector(
        '[data-package-total]'
      );

    if (visibleBoxCount > 0) {

      packageTotalElement.textContent =
        visibleBoxCount +
        (visibleBoxCount === 1
          ? ' Box'
          : ' Boxes');

      packageTotalRow.hidden = false;

    } else {

      packageTotalRow.hidden = true;

    }


    /* =========================
       SHOW / HIDE COMPONENT
    ========================= */

    if (
      visibleBoxCount === 0 &&
      !actualWeight
    ) {

      container.hidden = true;

    } else {

      container.hidden = false;

    }

  }


  /* =========================
     INITIAL LOAD
  ========================= */

  function initializePackageInfo() {

    console.log(
      '[Package Info] Initializing...'
    );

    document
      .querySelectorAll('[data-variant-package-info]')
      .forEach(function (container) {

        const variantId =
          container.dataset.currentVariantId;

        updatePackageInfo(
          container,
          variantId
        );

      });

  }


  /* =========================
     VARIANT CHANGE
  ========================= */

  document.addEventListener(
    'variant:change',
    function (event) {

      if (
        !event.detail ||
        !event.detail.variant
      ) {
        return;
      }

      const variantId =
        String(event.detail.variant.id);

      document
        .querySelectorAll('[data-variant-package-info]')
        .forEach(function (container) {

          const productId =
            container.dataset.productId;

          const jsonElement =
            document.querySelector(
              '[data-variant-package-json="' +
              productId +
              '"]'
            );

          if (!jsonElement) {
            return;
          }

          let allVariantData;

          try {

            allVariantData =
              JSON.parse(jsonElement.textContent);

          } catch (error) {

            console.error(
              'Unable to parse variant package data:',
              error
            );

            return;
          }

          /*
          * Only update this component if
          * the changed variant belongs to
          * this product.
          */
          if (!allVariantData[variantId]) {
            return;
          }

          container.dataset.currentVariantId =
            variantId;

          updatePackageInfo(
            container,
            variantId
          );

        });

    }
  );


  /* =========================
     START
  ========================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializePackageInfo
    );

  } else {

    initializePackageInfo();

  }

})();


// Close Package Information tab when variant changes
document.addEventListener('variant:change', function () {
  document
    .querySelectorAll('[data-variant-package-info]')
    .forEach(function (packageInfo) {
      const collapsible = packageInfo.closest('.collapsibles-wrapper');

      if (!collapsible) return;

      const trigger = collapsible.querySelector('.collapsible-trigger');
      const content = collapsible.querySelector('.collapsible-content');

      if (trigger) {
        trigger.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (content) {
        content.classList.remove('is-open');
        content.style.height = '';
      }
    });
});